import type { MultipleOpportunity, SingleOpportunity } from '@ps/isp-web-services-types';
import { useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';

import { getAvailableSingleOpportunities } from '@swf/core/models/sports/betSlip/utils/getAvailableOpportunities';
import { getIsSingleOpportunity } from '@swf/core/models/sports/betSlip/utils/getIsOpportunity';
import { select } from '@swf/core/store';

import type { FormData } from '../types';

const useIsMultipleStartingPriceOpportunity = (
  opportunity: SingleOpportunity | MultipleOpportunity
) => {
  const { values } = useFormState<FormData>({ subscription: { values: true } });
  const singleOpportunities = useSelector(select.betSlip.singleOpportunities);

  const isSingleOpportunity = getIsSingleOpportunity(opportunity);

  if (isSingleOpportunity) {
    return false;
  }

  const availableSingles = getAvailableSingleOpportunities(singleOpportunities);
  const { runnersIds } = opportunity;

  return runnersIds.some((runnerId) =>
    availableSingles.some((single) => {
      const { selectionId, marketId } = single.runnerId;
      const isSingleOpportunityPartOfMultiple =
        selectionId === runnerId.selectionId && marketId === runnerId.marketId;

      return (
        isSingleOpportunityPartOfMultiple &&
        (!single.winRunnerOdds || values[single.id]?.startingPriceSelected)
      );
    })
  );
};

export default useIsMultipleStartingPriceOpportunity;
